// Dependencies
import React, { useState } from 'react';

import InfiniteScrollList from '../../UI/InfiniteScrollList';

// Material UI Components
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Switch, FormControlLabel } from '@material-ui/core';
import { useLocation } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

// Tour

import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    backgroundColor: theme.palette.background.default,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 15,
      paddingRight: 15,
      marginTop: 20
    },
    [theme.breakpoints.up('xs')]: {
      marginTop: 20,
      paddingLeft: 15,
      paddingRight: 15
    },
    [theme.breakpoints.up(500)]: {
      marginTop: 40,
      paddingLeft: 15,
      paddingRight: 15
    },
    [theme.breakpoints.up('md')]: {
      marginTop: 40,
      paddingLeft: 12,
      paddingRight: 12
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: 40,
      paddingLeft: 33,
      paddingRight: 33
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: 40,
      paddingLeft: 80,
      paddingRight: 80
    }
  },
  filterButton: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: 20
  }

}));

const DocumentList = (props) => {
  const { user } = props;
  const classes = useStyles();

  const location = useLocation();

  const path = location.pathname.split('/');
  const last = path.pop();
  const { t } = useTranslation();

  const [filterBywaitingForMe, setFilterByWaitingForMe] = useState(false);

  return (
    <>
      <Grid container className={classes.mainContainer} direction='column'>
        <Grid container className={classes.filterButton} direction='column' item xs={12} md={10}>
          <Grid item xs={2}>
            {last === 'document' && (
              <FormControlLabel control={
                <Switch color='primary' onChange={() => setFilterByWaitingForMe(!filterBywaitingForMe)} />
              } label={t('documentListView:waitingForMe')} labelPlacement='top' />
            )}
          </Grid>
        </Grid>
        <Grid container item xs={12} md={10} style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          {user.attributes && <InfiniteScrollList filterByWaitingForMe={filterBywaitingForMe} />}
        </Grid>
      </Grid>

    </>
  );
};

DocumentList.propTypes = {
  // currentPath: PropTypes.string.isRequired,
  // documents: PropTypes.array.isRequired
  // location: PropTypes.object.isRequired,
  // role: PropTypes.string.isRequired
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    documents: state.documents
  };
};

export default connect(mapStateToProps, null)(DocumentList);
